import { apiClient } from "./client";

export const listPresets = () => apiClient.get("/leads/presets/").then((r) => r.data);
export const createPreset = (data) => apiClient.post("/leads/presets/", data).then((r) => r.data);
export const deletePreset = (id) => apiClient.delete(`/leads/presets/${id}`).then((r) => r.data);
